import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=7f529612&scoped=true&"
import script from "./sso.vue?vue&type=script&lang=js&"
export * from "./sso.vue?vue&type=script&lang=js&"
import style0 from "./sso.vue?vue&type=style&index=0&id=7f529612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f529612",
  null
  
)

export default component.exports